import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

const Popup = () => {
  const [popupIsOpen, setPopupIsOpen] = useState(false)
  const [currentPath, setCurrentPath] = useState(null)
  const [isBrowser, setIsBrowser] = useState(false)

  useEffect(() => {
    setIsBrowser(typeof window !== "undefined")
    if (typeof window !== "undefined") {
      setCurrentPath(window.location.pathname) // Get just the path part of the URL
    }
  }, [])

  useEffect(() => {
    if (!isBrowser) return

    const popupShown = sessionStorage.getItem("popupShown")

    if (popupIsOpen && popupShown !== "shown") {
      const popup = document.querySelector("#popup")
      const popupInner = document.querySelector(".popup__inner")
      const body = document.querySelector("body")

      if (popup && popupInner && body) {
        popup.style.display = "block"
        body.classList.add("lock-mobile-scroll")
        setTimeout(() => {
          popupInner.style.opacity = "1"
          popupInner.style.transform = "translateX(0)"
        }, 100)
      }
    }
  }, [popupIsOpen, isBrowser])

  const closePopup = () => {
    if (!isBrowser) return

    const popup = document.querySelector("#popup")
    const popupInner = document.querySelector(".popup__inner")
    const body = document.querySelector("body")

    if (popup && popupInner && body) {
      popupInner.style.opacity = "0"
      popupInner.style.transform = "translateX(5%)"
      body.classList.remove("lock-mobile-scroll")

      setTimeout(() => {
        popup.style.display = "none"
      }, 100)

      sessionStorage.setItem("popupShown", "shown")
    }
  }

  useEffect(() => {
    if (!isBrowser) return

    const timer = setTimeout(() => {
      setPopupIsOpen(true)
    }, 4000)

    return () => clearTimeout(timer)
  }, [isBrowser])

  // Only show popup if path is exactly "/properties/the-outpost/"
  if (!isBrowser || currentPath !== "/properties/the-outpost/") {
    return null
  }

  return (
    <section
      id="popup"
      className="popup py-[50px] px-[50px] bg-[rgb(35,31,32)] fixed z-[999999] bottom-[60px] right-[30px] mdscreen:right-0 mdscreen:bottom-0 w-[760px] mdscreen:w-full mdscreen:h-full"
      style={{ display: "none" }}
    >
      <div className="popup__inner flex mdscreen:flex-col mdscreen:justify-center mdscreen:h-full mdscreen:px-5 mdscreen:py-10 bg-black/50 opacity-0 translate-x-[5%] transition-all ease-linear duration-300">
        <div className="popup__img-wrapper w-[50%] mdscreen:w-full mdscreen:h-[250px]">
          <img
            src="https://wp.rareearth.co.za/app/uploads/2025/06/popUP.png"
            alt="Special offer"
            className="popup__img h-full w-full object-cover object-center"
          />
        </div>
        <div className="popup__content flex flex-col justify-center space-y-5 w-[50%] px-[20px] mdscreen:w-full mdscreen:h-auto mdscreen:max-h-full px-8 py-10 relative bg-white">
          <button
            aria-label="Close popup"
            onClick={closePopup}
            className="popup__close-btn absolute top-[-20px] right-[-20px] hover:cursor-pointer xlscreen:hidden"
          >
            <img
              src="https://wp.rareearth.co.za/app/uploads/2025/06/close.svg"
              alt="Close"
              className="popup__close-btn__icon h-[16px] w-[16px] object-contain"
            />
          </button>
          <div className="title-white">
            <h2 className="popup__heading text-[25px] font-[300] tracking-[2px] leading-[30px]">
              NEW SOUND SAFARI AT THE OUTPOST
            </h2>
          </div>
          <button
            aria-label="Close popup mobile"
            onClick={closePopup}
            className="popup__close-btn absolute z-[9999999] top-[0px] right-[0px] hover:cursor-pointer md:block xl:hidden"
          >
            <img
              src="https://wp.rareearth.co.za/app/uploads/2025/06/close.svg"
              alt="Close"
              className="popup__close-btn__icon h-[20px] w-[20px] object-contain"
            />
          </button>
          <div className="content text-white-100 ">
            <p
              className="popup__description overflow-hidden max-h-[160px]"
              style={{ fontWeight: "300", fontSize: "16px" }}
            >
              Join us on a fascinating auditory journey through the remote
              wilderness of the Northern Kruger and experience a safari like no
              other
            </p>
          </div>
          <div className="popup__buttons text-center bg-white-100 btn-custom mt-8 mdscreen:flex mdscreen:flex-col">
            <a
              href="https://www.rareearth.co.za/properties/the-outpost/sound-safari/"
              className="btn btn-[rgb(35,31,32)] hover:cursor-pointer mr-5 mdscreen:mr-0 mdscreen:text-center"
              rel="noopener noreferrer"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Popup
